module.exports = __webpack_public_path__ + "static/media/1firstscreen.5c8e061f.png";